module.exports = __webpack_public_path__ + "roboto-italic-webfont.5124fb0699939f341dcd.svg";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/assets/fonts/roboto-italic-webfont.svg
// module id = ../../../../../src/assets/fonts/roboto-italic-webfont.svg
// module chunks = styles